import { useAuthStore } from '../compliance_state/authStore'

export async function apiPost(path: string, body: any, token?: string) {
  const doReq = async (t?: string) => {
    return fetch(`${path}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(t ? { Authorization: `Token ${t}` } : {}),
      },
      body: JSON.stringify(body),
    })
  }

  let res = await doReq(token)
  if (res.status === 401) {
    const newToken = await useAuthStore.getState().refreshAccessToken()
    if (newToken) res = await doReq(newToken)
  }

  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(formatApiError(data))
  return data
}

export async function apiGet(path: string, token?: string) {
  const doReq = async (t?: string) => {
    return fetch(`${path}`, {
      method: 'GET',
      headers: {
        ...(t ? { Authorization: `Token ${t}` } : {}),
      },
    })
  }

  let res = await doReq(token)
  if (res.status === 401) {
    const newToken = await useAuthStore.getState().refreshAccessToken()
    if (newToken) res = await doReq(newToken)
  }

  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(formatApiError(data))
  return data
}


export async function apiPut(path: string, body: any, token?: string) {
  const doReq = async (t?: string) => fetch(`${path}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...(t ? { Authorization: `Token ${t}` } : {}),
    },
    body: JSON.stringify(body),
  })

  let res = await doReq(token)
  if (res.status === 401) {
    const newToken = await useAuthStore.getState().refreshAccessToken()
    if (newToken) res = await doReq(newToken)
  }
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(formatApiError(data))
  return data
}

export async function apiDelete(path: string, token?: string) {
  const doReq = async (t?: string) => fetch(`${path}`, {
    method: 'DELETE',
    headers: {
      ...(t ? { Authorization: `Token ${t}` } : {}),
    },
  })

  let res = await doReq(token)
  if (res.status === 401) {
    const newToken = await useAuthStore.getState().refreshAccessToken()
    if (newToken) res = await doReq(newToken)
  }
  if (res.status === 204) return {}
  const data = await res.json().catch(() => ({}))
  if (!res.ok) throw new Error(formatApiError(data))
  return data
}

function formatApiError(data: any) {
  if (!data) return 'Request failed'
  if (typeof data === 'string') return data
  if (data.detail) return data.detail
  if (typeof data === 'object') {
    return Object.entries(data)
      .map(([k, v]) => {
        if (Array.isArray(v)) return `${k}: ${v.join(', ')}`
        if (typeof v === 'object') return `${k}: ${JSON.stringify(v)}`
        return `${k}: ${v}`
      })
      .join('; ')
  }
  return 'Request failed'
}
